import React, { useContext } from 'react';
import { VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { OpacitySlider } from '@/components/opacity-slider';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { VectorPanelContext } from '../../context';
import { Tracker } from '../../utils';

const FALLBACK_OPACITY = 100;

export const TextOpacity: React.FC = () => {
    const { layerId, recordId } = useContext(VectorPanelContext)!;

    const editor = useEditor();
    const textOpacity = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as IVectorLayerProps;
        const { textInfo } = layerData;

        return textInfo ? textInfo.opacity : null;
    }) as number | null;

    const opacity = textOpacity != null ? ~~(textOpacity * 100) : FALLBACK_OPACITY;

    const setTextOpacity = (value: number, options = { writeHistory: true }) => {
        if (textOpacity == null) return;

        editor.getInstance(VectorLayer).setTextOpacity(layerId, value / 100, options);

        if (options.writeHistory) {
            Tracker.setTextOpacity({
                recordId,
                stageType: editor.stage.getType(),
                opacity: value,
                isVectorLayer: true,
            });
        }
    };

    return (
        <OpacitySlider
            value={opacity}
            onChange={(value) => setTextOpacity(value, { writeHistory: false })}
            onAfterChange={(value) => setTextOpacity(value, { writeHistory: true })}
        />
    );
};
